<script>
import API from '@/services/API.js';
var sha1 = require('sha1');
import Utils from '@/services/utils.js'
const { formatLicenceId } = Utils
import UiBadge from '@/components/ui/Badge'

export default {
  name: 'SelectListItemDatiMonitoring',
  components: {
    UiBadge,
  },
  props: {
    item:{type: Object},
  },
  methods: {
    formatLicenceId,
  },
  computed: {
    picture: function () {
      var hash = '0';
      if (this.item.deviceManufacturer != null && this.item.deviceModel != null) {
        hash = sha1(this.item.deviceManufacturer.toLowerCase() + this.item.deviceModel.toLowerCase().replace(new RegExp(' ', 'g'), ''));
      }
      const picture = API.route(API.endpoints.datis.picture, {hash: hash});
      return picture
    },
    status: function () {
      const pivot = this.item?.rmprocedures[0]?.pivot
      if (pivot && pivot.status == 5 && !pivot.status_reason) {
        return 'WAITING'
      }
      if (pivot && pivot.status == 5 && pivot.status_reason === 'unknown_error') {
        return 'ERROR'
      }
      // else status: "6"
      return 'SUCCESS'
    },
    procedure: function () {
      return this.item?.rmprocedures[0]?.name
    },
  },
}
</script>

<template>
  <div class="d-flex align-items-center pl-1">
    <div style="width: 40px;" class="text-center mr-1">
      <img v-if="!!picture.length" :src="picture" width="40" height="40" />
      <i v-else class="fa fa-mobile fa-2x text-muted"></i>
    </div>
    <div class="mr-auto">
      <h3 class="text-md font-weight-bold mb-0 text-md">{{ item.name }}</h3>
      <div v-if="item.id" class="d-flex align-items-center text-gray-500 text-sm">
        <span class="text-sm text-mono text-truncate text-muted">{{ formatLicenceId(item.id) }}</span>
      </div>
    </div>
    <div class="text-right">
      <div 
        v-if="!item.slot1PhoneNumber && !item.slot2PhoneNumber"
        class="alert alert-danger alert-sm p-1 pr-2 text-sm text-truncate"
      >
        <i class="fa fa-exclamation-triangle mr-1"></i>
        {{ $t("remoteMonitoring.device_status.missing_number") }}
      </div>
      <UiBadge v-if="status === 'ERROR'" type="danger">{{ $t("remoteMonitoring.device_status.fail") }}</UiBadge>
      <UiBadge v-if="status === 'WAITING'" type="info">{{ $t("remoteMonitoring.device_status.waiting") }}</UiBadge>
      <div class="text-sm text-muted" v-if="!!procedure">
        <i class="fa fa-bullhorn mr-1"></i> {{procedure }}
      </div>
    </div>
  </div>
</template>